<template>
  <div class="content-width py-4">
    <div class="member-tab">
      <ul class="nav nav-tabs" :class="{ 'nav-justified': isMobile }">
        <li class="nav-item">
          <a
            class="nav-link north"
            @click="clickArea('north')"
            :class="{ active: isActiveArea == 'north' }"
            href="javascript:;"
            >北部</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link middle"
            @click="clickArea('middle')"
            :class="{ active: isActiveArea == 'middle' }"
            href="javascript:;"
            >中部</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link south"
            @click="clickArea('south')"
            :class="{ active: isActiveArea == 'south' }"
            href="javascript:;"
            >南部</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link east"
            @click="clickArea('east')"
            :class="{ active: isActiveArea == 'east' }"
            href="javascript:;"
            >東部</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link east"
            @click="clickArea('offshore')"
            :class="{ active: isActiveArea == 'offshore' }"
            href="javascript:;"
            >離島</a
          >
        </li>
      </ul>
    </div>
    <div class="pt-4">
      <b-table
        v-if="!isMobile"
        responsive
        striped
        hover
        bordered
        head-variant="light"
        :items="items"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
        empty-text="目前尚無資料"
        empty-filtered-text="沒有找到符合的會員"
        show-empty
      >
        <template v-slot:head()="scope">
          <div class="text-nowrap">
            {{ scope.label }}
          </div>
        </template>
        <template v-slot:emptyfiltered="{ emptyFilteredText }">
          <div class="text-center">{{ emptyFilteredText }}</div>
        </template>
        <template v-slot:cell(address)="data">
          {{
            completeAddress(
              data.item.city_id,
              data.item.town_id,
              data.item.address
            )
          }}
        </template>
      </b-table>
      <b-table
        v-else
        striped
        bordered
        head-variant="light"
        :items="items"
        :fields="fields_mobile"
        :per-page="perPage"
        :current-page="currentPage"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
        empty-text="目前尚無資料"
        empty-filtered-text="沒有找到符合的廠商"
        show-empty
      >
        <template v-slot:head()="scope">
          <div class="text-nowrap">
            {{ scope.label }}
          </div>
        </template>
        <template v-slot:emptyfiltered="{ emptyFilteredText }">
          <div class="text-center">{{ emptyFilteredText }}</div>
        </template>
        <template v-slot:cell(show_details)="row">
          <div class="btn-only-icon">
            <b-button
              @click="row.toggleDetails"
              class="btn-link border-0"
              variant="outline-light"
              size="sm"
            >
              <b-icon
                :icon="row.detailsShowing ? 'chevron-down' : 'chevron-right'"
                variant="dark"
              ></b-icon>
            </b-button>
          </div>
        </template>
        <template v-slot:row-details="row">
          <b-card>
            <b-row class="mb-3">
              <b-col sm="3"><b>廠商名稱</b></b-col>
              <b-col>{{ row.item.company_name }}</b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col sm="3"><b>負責人</b></b-col>
              <b-col>{{ row.item.principal }}</b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col sm="3"><b>統一編號</b></b-col>
              <b-col>{{ row.item.tax_id }}</b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col sm="3"><b>地址</b></b-col>
              <b-col>{{
                completeAddress(
                  row.item.city_id,
                  row.item.town_id,
                  row.item.address
                )
              }}</b-col>
            </b-row>
            <b-row class="">
              <b-col class="text-center">
                <b-button
                  size="sm"
                  squared
                  variant="manage_main"
                  @click="row.toggleDetails"
                  >收起詳細資訊</b-button
                >
              </b-col>
            </b-row>
          </b-card>
        </template>
      </b-table>
      <div class="row align-items-center" v-if="totalRows">
        <div class="col-sm col-12 text-right text-sm-left">
          顯示第 {{ currentPage == 1 ? 1 : perPage * (currentPage - 1) + 1 }} 至
          {{
            currentPage == 1
              ? totalRows > perPage
                ? perPage
                : totalRows
              : perPage * (currentPage - 1) + perPage > totalRows
              ? totalRows
              : perPage * (currentPage - 1) + perPage
          }}
          項結果，共 {{ totalRows }} 項
        </div>
        <div class="col-sm col-12">
          <b-pagination
            v-if="totalRows > perPage"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="right"
            first-number
            last-number
            class="mb-sm-0 mb-3 mt-sm-0 mt-3 manage_main"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.member-tab {
  background-color: #fff;
  .nav-tabs {
    border: none;
    .nav-link {
      color: #666;
      position: relative;
      &::after {
        content: "";
        width: 0;
        left: 50%;
        transform: translate(-50%, 50%);
        transition: all 0.3s ease-in-out;
      }
      &:hover,
      &:focus {
        border-color: transparent;
        &::after {
          content: "";
          width: 100%;
          height: 3px;
          background-color: #666;
          position: absolute;
          bottom: 0;
        }
      }
    }
    .nav-link.active,
    .nav-item.show .nav-link {
      border: none;
      color: #fff;
      background-color: $manage_main;
      &::after {
        content: "";
        width: 100%;
        height: 3px;
        background-color: $manage_sub;
        position: absolute;
        bottom: 0;
      }
    }
  }
}
</style>

<script>
import { User } from "@/assets/api/manage.js";
import { Toast } from "@/plugins/sweetalert2.js";
import { getZone } from "@/assets/api.config.js";

export default {
  name: "Member",
  props: ["search", "isMobile", "token"],
  data() {
    return {
      TW_city_town: null,
      users: null,
      totalRows: null,
      currentPage: 1,
      perPage: 10,
      fields: [
        {
          key: "name",
          label: "姓名",
          tdClass: "align-middle",
          sortable: true,
          thStyle: "min-width: 5rem"
        },
        {
          key: "telephone",
          label: "手機號碼",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "company_name",
          label: "廠商名稱",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "principal",
          label: "負責人",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "tax_id",
          label: "統編",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "address",
          label: "地址",
          tdClass: "align-middle",
          thStyle: "min-width: 10rem"
        }
      ],
      fields_mobile: [
        {
          key: "show_details",
          label: "",
          tdClass: "align-middle",
          thStyle: "width:35px"
        },
        {
          key: "name",
          label: "姓名",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "telephone",
          label: "手機號碼",
          tdClass: "align-middle",
          sortable: true
        }
      ],
      filter: null,
      filterOn: ["name"],
      isActiveArea: "north"
    };
  },
  created() {
    this.perPage = process.env.VUE_APP_TABLE_ROW_LENGTH || 15;
    this.filter = this.search;
    User.get(this.token)
      .then(res => {
        if (res.status <= 201) {
          console.log(res);
          this.users = res.data;
          if (res.data.length) {
            this.totalRows = this.users[this.isActiveArea].length;
          }
        } else {
          Toast.fire({
            icon: "error",
            title: "會員資料讀取失敗",
            text: res.data.error
          });
        }
      })
      .catch(err => {
        console.error(err);
      });
    getZone()
      .then(res => {
        if (res.status <= 201) {
          this.TW_city_town = res.data;
        } else {
          Toast.fire({
            icon: "error",
            title: "地區資料讀取失敗",
            text: res.data.error
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  },
  computed: {
    items: function() {
      let getUser = null;
      if (this.users) {
        getUser = this.users[this.isActiveArea];
      }
      return getUser;
    }
  },
  methods: {
    completeAddress(city_id, town_id, address) {
      let cityName = "";
      let townName = "";
      let postcode = "";
      this.TW_city_town.forEach(city => {
        if (city.id == city_id) {
          cityName = city.city_name;
          city.towns.forEach(town => {
            if (town.id == town_id) {
              townName = town.town_name;
              postcode = town.postcode;
            }
          });
        }
      });
      return postcode + cityName + townName + (address || "");
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    clickArea(area) {
      this.isActiveArea = area;
      // this.$router.push({
      //   query: { area: area }
      // });
    }
  },
  mounted() {
    // console.log(this.$route.query.area);
    // if(!this.$route.query.area){
    //   this.$router.push({
    //     query: { area: this.isActiveArea }
    //   });
    // }else{
    //   this.isActiveArea = this.$route.query.area
    // }
  }
};
</script>
